
const AuthorizationActionType = {
    USER_AUTHORIZED: 'USER_AUTHORIZED',
    USER_UNAUTHORIZED: 'USER_UNAUTHORIZED',
    CHECK_AUTH_TOKEN: 'CHECK_AUTH_TOKEN',
    CHECK_AUTH_TOKEN_LOADING: 'CHECK_AUTH_TOKEN_LOADING',
    SET_REQUEST_KEY: 'SET_REQUEST_KEY',
    SET_LOGGEDIN_MOBILE_NUMBER: 'SET_LOGGEDIN_MOBILE_NUMBER',
    SET_SELECTED_NUMBER: 'SET_SELECTED_NUMBER',

    //Api status
    //Login info api status
    LOGIN_INFO_SUCCESS: 'LOGIN_INFO_SUCCESS',
    LOGIN_INFO_ERROR: 'LOGIN_INFO_ERROR',
    LOGIN_INFO_LOADING: 'LOGIN_INFO_LOADING',
    //Check user api status
    CHECK_USER_SUCCESS: 'CHECK_USER_SUCCESS',
    CHECK_USER_ERROR: 'CHECK_USER_ERROR',
    CHECK_USER_LOADING: 'CHECK_USER_LOADING',
    //Generate otp api status
    GENERATE_OTP_SUCCESS: 'GENERATE_OTP_SUCCESS',
    GENERATE_OTP_ERROR: 'GENERATE_OTP_ERROR',
    GENERATE_OTP_LOADING: 'GENERATE_OTP_LOADING',
    //Validate otp api status
    VALIDATE_OTP_SUCCESS: 'VALIDATE_OTP_SUCCESS',
    VALIDATE_OTP_ERROR: 'VALIDATE_OTP_ERROR',
    VALIDATE_OTP_LOADING: 'VALIDATE_OTP_LOADING',
    //Auth login api status
    AUTH_LOGIN_SUCCESS: 'AUTH_LOGIN_SUCCESS',
    AUTH_LOGIN_ERROR: 'AUTH_LOGIN_ERROR',
    AUTH_LOGIN_LOADING: 'AUTH_LOGIN_LOADING',
    //Fetch SSO Profile api status
    FETCH_SSO_PROFILE_SUCCESS: 'FETCH_SSO_PROFILE_SUCCESS',
    FETCH_SSO_PROFILE_ERROR: 'FETCH_SSO_PROFILE_ERROR',
    FETCH_SSO_PROFILE_LOADING: 'FETCH_SSO_PROFILE_LOADING',

    //Set Mobile App Auth Token 
    SET_MOBILE_APP_AUTH_TOKEN: 'SET_MOBILE_APP_AUTH_TOKEN',

}

export default AuthorizationActionType